import { mapHouseItem } from '@/common/utils/map_view_data'

export const WHOLE_CITY = '全城'

export const handleItems = (items) => {
    return items.map((item, i) => {
        return {
            ...mapHouseItem(item),
            ranking_order: i + 1
        }
    })
}

export const getViewCount =(item, page_view_counts) => {
    const count = page_view_counts[item.text]
    return count ? `${(count / 10000).toFixed(1)}w人看过` : ''
}
